import { Content as ContentComponent } from 'gatsby-theme-marketplace-base/src/components/ProductList/Header/Content'

import { Search } from './Search'

export const Content = (props) => (
  <ContentComponent {...props}>
    <Search />
  </ContentComponent>
)
